function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  .details-enter > &,\n  .details-exit > & {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  &.details-enter,\n  &.details-exit {\n    pointer-events: none;\n  }\n\n  &.details-enter {\n    transition: height ", " ease 0ms, opacity ", " ease ", ";\n  }\n\n  &.details-exit {\n    transition: opacity ", " ease 0ms, height ", " ease ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled from "../../theme";

var halfDuration = function halfDuration(_ref) {
  var animationDuration = _ref.animationDuration;
  return animationDuration ? "".concat(animationDuration / 2, "ms") : '0ms';
};

export var ExpandableContentWrapper = styled.div(_templateObject(), halfDuration, halfDuration, halfDuration, halfDuration, halfDuration, halfDuration);
export var ExpandableContentContent = styled.div(_templateObject2());